const Footer = () => {
  return (
    <footer className=' flex center'>
      <small>&copy; oshingate@gmail.com</small>
    </footer>
  );
};

export default Footer;
